import React from 'react';
import EnhancedModal from '@components/generic-modal/EnhancedModal';
import { IPolicyBankersDetails } from '../../../..';
import BankersBlanketPopUp from './BankersBlanketPopUp';

interface IBankersBlanketPopUpShellProps {
  open: boolean;
  currencySymbol: string;
  bankersData: IPolicyBankersDetails[];
  lovs: Record<string, Record<string, string>>;
  onClose: () => void;
  onSuccess: () => void;
}

const BankersBlanketPopUpShell: React.FC<IBankersBlanketPopUpShellProps> = ({
  open,
  currencySymbol,
  bankersData,
  lovs,
  onClose,
  onSuccess,
}) => {
  return (
    <EnhancedModal
      open={open}
      blur={true}
      onClose={onClose}
      title="Modify Bankers Blanket Bond popup"
    >
      <BankersBlanketPopUp
        currencySymbol={currencySymbol}
        data={bankersData}
        lovs={lovs}
        onClose={onClose}
        onSuccess={onSuccess}
      />
    </EnhancedModal>
  );
};

export default BankersBlanketPopUpShell;
